import { JoinProFormController, SeoController } from '@application/components';
import { JOIN_PRO_INFO_ROUTE_PER_PRO_PER_TYPE } from '@application/constants';
import { useRouter } from '@application/utils';
import { ProfessionalTypeEnum } from '@gql/graphql';
import { JoinProPage } from '@presentation/pages';
import { useTranslation } from '@presentation/utils';
import type { FC } from 'react';

export const JoinVetPageController: FC = () => {
  const { routeLocationDescriptor } = useRouter();
  const { translate: translateWithType } = useTranslation({
    keyPrefix: 'joinPro.VET',
  });

  return (
    <>
      <SeoController
        title={translateWithType('seo.title')}
        description={translateWithType('seo.description')}
        keywords={translateWithType('seo.keywords')}
      />
      <JoinProPage
        type={ProfessionalTypeEnum.VET}
        links={{
          SEO: routeLocationDescriptor(JOIN_PRO_INFO_ROUTE_PER_PRO_PER_TYPE.VET.SEO),
          PROFILE: routeLocationDescriptor(JOIN_PRO_INFO_ROUTE_PER_PRO_PER_TYPE.VET.PROFILE),
          AGENDA: routeLocationDescriptor(JOIN_PRO_INFO_ROUTE_PER_PRO_PER_TYPE.VET.AGENDA),
          BOOKING: routeLocationDescriptor(JOIN_PRO_INFO_ROUTE_PER_PRO_PER_TYPE.VET.BOOKING),
        }}
        formComponent={<JoinProFormController type={ProfessionalTypeEnum.VET} />}
      />
    </>
  );
};
